(() => {
  const ids = {'55945691726204':67856248078551,'57767751025020':67856260038871,'57358742913404':67856260268247,'57468650062204':67856248078551};
  const overlay = document.querySelector('.cl-cart-overlay');
  const drawer = document.querySelector('.cl-cart-drawer');
  if (!overlay || !drawer) return;
  // Captured accelerated buttons reference a different shop; use the local checkout CTA.
  const checkoutStyle=document.createElement('style');
  checkoutStyle.textContent='.cl-reference-main .shopify-payment-button{display:none!important}';
  document.head.append(checkoutStyle);
  const money = (cents, currency) => new Intl.NumberFormat('en-US', {style:'currency',currency:currency||'USD'}).format(cents/100);
  const close = () => {drawer.hidden=true;overlay.hidden=true;document.body.style.overflow='';};
  const open = async () => {drawer.hidden=false;overlay.hidden=false;document.body.style.overflow='hidden';await refresh();};
  async function refresh() {
    const response=await fetch('/cart.js',{credentials:'same-origin'});
    if (!response.ok) return;
    const cart=await response.json();
    document.querySelectorAll('.cl-cart-count').forEach(e=>e.textContent=cart.item_count ? String(cart.item_count) : '');
    const box=drawer.querySelector('.cl-cart-items');box.replaceChildren();
    if (!cart.items.length) box.textContent='Your cart is empty';
    for (const [itemIndex,item] of cart.items.entries()) {
      const line=document.createElement('div');line.className='cl-cart-line';
      if(item.image){const img=document.createElement('img');img.src=item.image;img.alt='';line.append(img);}
      const details=document.createElement('div');const title=document.createElement('strong');title.textContent=item.product_title;
      const amount=document.createElement('span');amount.textContent=`${item.quantity} × ${money(item.final_price,cart.currency)}`;
      const plan=item.selling_plan_allocation?.selling_plan;
      const purchaseType=document.createElement('p');
      purchaseType.style.cssText='font-size:13px;line-height:1.5;margin:6px 0;color:#64258D';
      purchaseType.textContent=plan?'Subscription: '+plan.name+'. Recurring charges apply.':'One-time purchase';
      const oneTime=document.createElement('button');
      oneTime.type='button';oneTime.textContent='Switch to one-time purchase';
      oneTime.style.cssText='display:block;margin-top:8px;padding:8px 10px;border:1px solid #64258D;border-radius:6px;background:#fff;color:#64258D;font:inherit;font-size:13px;cursor:pointer';
      oneTime.addEventListener('click',async()=>{
        oneTime.disabled=true;oneTime.textContent='Updating purchase type...';
        try{
          const response=await fetch('/cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:itemIndex+1,quantity:item.quantity,selling_plan:null})});
          if(!response.ok){const error=await response.json();throw Error(error.description||'Could not change purchase type. Please try again.');}
          await refresh();
        }catch(error){window.alert(error.message);oneTime.disabled=false;oneTime.textContent='Switch to one-time purchase';}
      });
      const controls=document.createElement('div');controls.className='cl-cart-controls';
      const decrease=document.createElement('button');decrease.type='button';decrease.textContent='−';decrease.setAttribute('aria-label','Decrease quantity');
      const quantity=document.createElement('span');quantity.textContent=String(item.quantity);
      const increase=document.createElement('button');increase.type='button';increase.textContent='+';increase.setAttribute('aria-label','Increase quantity');
      const remove=document.createElement('button');remove.type='button';remove.textContent='Remove';remove.className='cl-cart-remove';
      async function changeQuantity(next){
        for(const button of [decrease,increase,remove])button.disabled=true;
        try{
          const response=await fetch('/cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:item.key,quantity:next})});
          if(!response.ok){const error=await response.json();throw Error(error.description||'Could not update cart');}
          await refresh();
        }catch(error){window.alert(error.message);for(const button of [decrease,increase,remove])button.disabled=false;}
      }
      decrease.addEventListener('click',()=>changeQuantity(Math.max(0,item.quantity-1)));
      increase.addEventListener('click',()=>changeQuantity(item.quantity+1));
      remove.addEventListener('click',()=>changeQuantity(0));
      controls.append(decrease,quantity,increase,remove);
      details.append(title,amount,purchaseType,controls);if(plan)details.append(oneTime);line.append(details);box.append(line);
    }
    const total=drawer.querySelector('.cl-cart-total');total.replaceChildren();
    const label=document.createElement('strong');label.textContent='Subtotal';const value=document.createElement('strong');value.textContent=money(cart.total_price,cart.currency);total.append(label,value);
  }
  const formSelector='form[action="/cart/add"], form[action="/cart/add.js"]';
  function formFor(node){
    const own=node?.closest(formSelector);
    if(own)return own;
    const flow=node?.closest('.cl-pdp-mobile, .cl-pdp-desktop, .cl-reference-main');
    for(let parent=node?.parentElement;parent;parent=parent.parentElement){
      const forms=[...parent.querySelectorAll(formSelector)];
      if(forms.length===1)return forms[0];
      if(parent===flow)break;
    }
    const forms=[...(flow||document).querySelectorAll(formSelector)];
    return forms.find(form=>form.getClientRects().length)||forms[0]||null;
  }
  function setQuantity(form,quantity){
    if(!form||!quantity)return;
    const input=form.querySelector('input[name="quantity"]');
    if(input)input.value=String(quantity);
    form.dataset.clBundleQuantity=String(quantity);
  }
  function variantFor(form){
    const source=form?.querySelector('input[name="id"]')?.value;
    // This landing page uses an older main-product form on desktop for Elderberry.
    if(location.pathname.replace(/\/$/,'')==='/pages/pdp-auto' && form?.closest('.cl-pdp-desktop, .cl-pdp-mobile'))return 67856260268247;
    return ids[source]||Number(source);
  }
  const offerRows=[...document.querySelectorAll('#elvp .elvp-r')];
  const offerQuantities=[1,3,5];
  const topDealRadios=[...document.querySelectorAll('input[type="radio"][name^="kaching-bundles-deal"]')];
  const bundleGroups=[];
  const refillSelected=()=>Boolean(window.CL_REFILL&&window.CL_REFILL.on());
  const tierCents=()=>[3360,6720,10080];
  function syncBundlePrices(){
    const totals=tierCents();
    document.querySelectorAll('.cl-reference-main .kaching-bundles__bars').forEach(root=>{
      [...root.querySelectorAll('.kaching-bundles__bar')].forEach((bar,index)=>{
        if(!offerQuantities[index])return;
        const price=bar.querySelector('.kaching-bundles__bar-price');
        const expected=money(totals[index]);
        if(price&&price.textContent.trim()!==expected)price.textContent=expected;
        const compare=bar.querySelector('.kaching-bundles__bar-full-price');
        const compareCents=Math.round(Number((compare?.textContent||'').replace(/[^0-9.]/g,''))*100);
        const subtitle=bar.querySelector('.kaching-bundles__bar-subtitle');
        if(subtitle&&compareCents&&/Save\s+\$[\d,.]+/.test(subtitle.textContent)){
          const next=subtitle.textContent.replace(/Save\s+\$[\d,.]+/, 'Save '+money(Math.max(0,compareCents-totals[index])));
          if(subtitle.textContent!==next)subtitle.textContent=next;
        }
      });
    });
  }
  const groupRoots=[...new Set(topDealRadios.map(radio=>radio.closest('.kaching-bundles__bars')||radio.closest('kaching-bundles-block')).filter(Boolean))];
  for(const root of groupRoots){
    const radios=[...root.querySelectorAll('input[type="radio"][name^="kaching-bundles-deal"]')];
    const group={root,radios,form:formFor(root)};
    bundleGroups.push(group);
    const selected=radios.findIndex(radio=>radio.checked||radio.closest('.kaching-bundles__bar')?.classList.contains('kaching-bundles__bar--selected'));
    selectBundle(group,selected>=0?selected:Math.min(1,radios.length-1));
    root.addEventListener('click',event=>{
      const bar=event.target.closest('.kaching-bundles__bar');
      const index=radios.findIndex(radio=>radio.closest('.kaching-bundles__bar')===bar);
      if(index>=0)selectBundle(group,index,true);
    });
    root.addEventListener('keydown',event=>{
      if(event.key!=='Enter'&&event.key!==' ')return;
      const bar=event.target.closest('.kaching-bundles__bar');
      const index=radios.findIndex(radio=>radio.closest('.kaching-bundles__bar')===bar);
      if(index>=0){event.preventDefault();selectBundle(group,index,true);}
    });
  }
  function selectBundle(group,index,syncOffer=false){
    if(index<0||index>=group.radios.length)return;
    group.radios.forEach((radio,i)=>{
      radio.checked=i===index;
      const bar=radio.closest('.kaching-bundles__bar');
      bar?.classList.toggle('kaching-bundles__bar--selected',i===index);
      bar?.setAttribute('aria-checked',String(i===index));
    });
    setQuantity(group.form,offerQuantities[index]);
    if(syncOffer&&offerRows.length&&formFor(offerRows[0])===group.form)selectOffer(index);
  }
  function selectOffer(index){
    if(index<0||index>=offerRows.length)return;
    offerRows.forEach((row,i)=>{
      row.classList.toggle('on',i===index);
      row.setAttribute('aria-checked',String(i===index));
    });
    const form=formFor(offerRows[index]);
    setQuantity(form,offerQuantities[index]);
    bundleGroups.filter(group=>group.form===form).forEach(group=>selectBundle(group,index));
    const atc=document.querySelector('.elvk-atc span');
    if(atc){
      const icon=atc.querySelector('svg')?.outerHTML||'';
      atc.innerHTML=icon+'Add To Cart - '+money(tierCents()[index])+' <s>'+offerRows[index].dataset.compare+'</s>';
    }
  }
  if(offerRows.length){
    offerRows.forEach((row,i)=>{
      const price=row.querySelector('.elvp-pr');
      const saving=row.querySelector('.elvp-s');
      const perBottle=row.querySelector('.elvp-pb');
      if(price && row.dataset.priceSub)price.textContent=row.dataset.priceSub;
      if(saving && row.dataset.saveSub)saving.textContent='You save '+row.dataset.saveSub;
      if(perBottle && row.dataset.priceSub)perBottle.textContent=[null,'$22.40 / bottle','$20.16 / bottle'][i]||'';
      row.addEventListener('click',()=>selectOffer(i));
    });
    selectOffer(Math.max(0,offerRows.findIndex(row=>row.classList.contains('on'))));
  }
  const gooseberryOffers=[...document.querySelectorAll('.gbk-offer')];
  let gooseberryQuantity=3;
  gooseberryOffers.forEach(row=>row.addEventListener('click',()=>{
    gooseberryQuantity=Number(row.dataset.quantity)||1;
    gooseberryOffers.forEach(other=>{other.classList.toggle('is-selected',other===row);other.setAttribute('aria-checked',String(other===row));});
    const buttonText=document.querySelector('.gbk-atc span');
    if(buttonText){const icon=buttonText.querySelector('svg')?.outerHTML||'';buttonText.innerHTML=icon+'Add To Cart - '+row.dataset.price+' <s>'+row.dataset.compare+'</s>';}
  }));
  overlay.addEventListener('click',close);
  drawer.querySelector('.cl-cart-close').addEventListener('click',close);
  document.querySelectorAll('.cl-cart-open').forEach(e=>e.addEventListener('click',open));
  document.addEventListener('keydown',e=>{if(e.key==='Escape')close();});
  document.addEventListener('click',e=>{
    const gooseberryButton=e.target.closest('.cl-reference-main a.gbk-atc');
    if(gooseberryButton){e.preventDefault();e.stopImmediatePropagation();add(67856260038871,gooseberryQuantity,gooseberryButton);return;}
    const cartLink=e.target.closest('.cl-reference-main a[href="/cart"]');
    if(cartLink){e.preventDefault();open();return;}
    const sourceButton=e.target.closest('.cl-reference-main a.elvk-atc');
    if(!sourceButton)return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const form=formFor(sourceButton);
    const selected=offerRows.findIndex(row=>row.classList.contains('on'));
    const qty=selected>=0?offerQuantities[selected]:(Number(form?.querySelector('input[name="quantity"]')?.value)||3);
    add(variantFor(form),qty,sourceButton);
  },true);
  const menu=document.querySelector('.cl-mobile-menu');const menuButton=document.querySelector('.cl-mobile-menu-button');
  if(menu&&menuButton)menuButton.addEventListener('click',()=>{menu.hidden=!menu.hidden;menuButton.setAttribute('aria-expanded',String(!menu.hidden));});
  document.querySelectorAll('.cl-reference-main video').forEach(video=>{
    if(!video.src&&video.dataset.src)video.src=video.dataset.src;
    if(!video.controls)video.controls=true;
    video.preload='metadata';
  });
  document.querySelectorAll('.cl-reference-main .gp-featured-image-wrapper').forEach(feature=>{
    const track=feature.querySelector('.gem-slider-wrapper');
    const slides=[...feature.querySelectorAll('.gem-slider-item')];
    if(!track||slides.length<2)return;
    const gallery=feature.closest('gp-product-images-v3');
    const thumbs=[...gallery?.querySelectorAll('.swiper-thumbs .gem-slider-item')||[]];
    let index=0;
    track.style.transition='transform .3s ease';
    const show=n=>{index=(n+slides.length)%slides.length;track.style.transform=`translate3d(${-index*100}%,0,0)`;thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-current',String(i===index)));};
    thumbs.forEach((thumb,i)=>{thumb.setAttribute('role','button');thumb.setAttribute('tabindex','0');thumb.addEventListener('click',()=>show(i));thumb.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();show(i);}});});
    feature.querySelector('.gp-carousel-action-back')?.addEventListener('click',e=>{e.preventDefault();show(index-1);});
    feature.querySelector('.gp-carousel-action-next')?.addEventListener('click',e=>{e.preventDefault();show(index+1);});
    show(0);
  });
  document.addEventListener('change',e=>{
    if(e.target.matches('#cl-refill-cb')){syncBundlePrices();return;}
    if (!e.target.matches('input[type="radio"][name^="kaching-bundles-deal"]')) return;
    const group=bundleGroups.find(group=>group.radios.includes(e.target));
    if(group)selectBundle(group,group.radios.indexOf(e.target),true);
  });
  syncBundlePrices();
  window.addEventListener('load',syncBundlePrices,{once:true});
  const priceRoot=document.querySelector('.cl-reference-main');
  if(priceRoot){
    // Only update changed leaf text: keep captured event handlers and avoid observer loops.
    new MutationObserver(syncBundlePrices).observe(priceRoot,{childList:true,subtree:true,characterData:true});
  }
  let adding=false;
  async function add(id,qty,button){
    if(adding)return;
    if(!Number.isSafeInteger(id)||id<=0||!Number.isInteger(qty)||qty<1){window.alert('Please select a product and quantity.');return;}
    adding=true;
    if(button)button.setAttribute('aria-disabled','true');
    let navigating=false;
    try {
      const cleared=await fetch('/cart/clear.js',{method:'POST',credentials:'same-origin',headers:{'Accept':'application/json'}});
      if(!cleared.ok)throw Error('Could not prepare your checkout. Please try again.');
      const response=await fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[Object.assign({id,quantity:qty},(window.CL_REFILL&&window.CL_REFILL.on())?{selling_plan:window.CL_REFILL.id}:{})]})});
      if(!response.ok){const error=await response.json();throw Error(error.description||'Could not add item');}
      navigating=true;
      window.location.assign('/checkout');
    } catch(error) { window.alert(error.message); }
    finally {if(!navigating){adding=false;if(button)button.removeAttribute('aria-disabled');}}
  }
  document.addEventListener('submit',e=>{
    const form=e.target;
    if (!form.matches('.cl-reference-main form[action="/cart/add"], .cl-reference-main form[action="/cart/add.js"]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const qty=Math.max(1,Number(form.querySelector('input[name="quantity"]')?.value)||Number(form.dataset.clBundleQuantity)||1);
    add(variantFor(form),qty,e.submitter);
  },true);
  refresh();
})();
